import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=5afe2d12&scoped=true&"
var script = {}
import style0 from "./Sources.vue?vue&type=style&index=0&id=5afe2d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afe2d12",
  null
  
)

export default component.exports